import { AuthLayout } from './AuthLayout';
import { Login } from './Login';

export const Auth = () => {
  return (
    <AuthLayout>
      <Login />
    </AuthLayout>
  );
};
